import { Route, Routes, BrowserRouter as Router, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import 'datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css';
import 'datatables.net-buttons-bs5/css/buttons.bootstrap5.min.css';
import "lineicons/dist/lineicons.css";
import 'boxicons/css/boxicons.min.css';
import 'simplebar-react/dist/simplebar.min.css';
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";
import "datatables.net-buttons";
import "datatables.net-buttons-bs5";
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";
import "quill/dist/quill.snow.css";
import './App.css';
import Home from './pages/Home';
import ClubManagement from './pages/ClubManagement';
import RefereeDetail from './pages/RefereeDetail';
import RefereeManagement from './pages/RefereeManagement';
import ClubDetail from './pages/ClubDetail';
import GameScheduling from './pages/GameScheduling';
import GameManagement from './pages/GameManagement';
import Finances from './pages/Finances';
import RolesManagement from './pages/RolesManagement';
import ChildReferees from './pages/ChildReferees';
import Notifications from './pages/Notifications';
import Settings from './pages/Settings';
import Profile from './pages/Profile';
import AuthCoverSignin from './pages/auth/AuthCoverSignin';
import AuthLayout from './AuthLayout';
import MainLayout from './MainLayout';
import AuthCoverForgotPassword from './pages/auth/AuthCoverForgotPassword';
import AuthCoverSignup from './pages/auth/AuthCoverSignup';
import AuthCoverResetPassword from './pages/auth/AuthCoverResetPassword';
import "nprogress/nprogress.css";
import { useEffect } from 'react';
import nProgress from 'nprogress';



function App() {
  const location = useLocation();

  useEffect(() => {
    nProgress.start();

    const timer = setTimeout(() => {
      nProgress.done();
    }, 300);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <>
      <Routes>
        <Route element={<AuthLayout />}>
          <Route path='/auth-cover-signin' element={<AuthCoverSignin />} />
          <Route path='/auth-cover-forgot-password' element={<AuthCoverForgotPassword />} />
          <Route path='/auth-cover-signup' element={<AuthCoverSignup />} />
          <Route path='/auth-cover-reset-password' element={<AuthCoverResetPassword />} />
        </Route>
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path='/club-management' element={<ClubManagement />} />
          <Route path='/referee-detail' element={<RefereeDetail />} />
          <Route path='/referee-management' element={<RefereeManagement />} />
          <Route path='/club-detail' element={<ClubDetail />} />
          <Route path='/game-scheduling' element={<GameScheduling />} />
          <Route path='/game-management' element={<GameManagement />} />
          <Route path='/child-referees' element={<ChildReferees />} />
          <Route path='/finances' element={<Finances />} />
          <Route path='/roles-management' element={<RolesManagement />} />
          <Route path='/notifications' element={<Notifications />} />
          <Route path='/settings' element={<Settings />} />
          <Route path='/profile' element={<Profile />} />
        </Route>
      </Routes>
    </>
  );
}

const WrappedApp = () => (
  <Router>
    <App />
  </Router>
);

export default WrappedApp;
